import NewOrganizationModal from './NewOrganizationModal'

export default NewOrganizationModal
